class InMemoryCacheStorage implements Storage {
    private _length = 0;
    private data: { [key: string]: string } = {};

    readonly [name: string]: any;

    public get length(): number {
        return this._length;
    }

    clear(): void {
        this.data = {};
        this._length = 0;
    }

    getItem(key: string): string | null {
        return this.data[key];
    }

    key(index: number): string | null {
        return this.keys[index];
    }

    removeItem(key: string): void {
        const existingData = this.data[key];
        if (existingData !== undefined) {
            delete this.data[key];
        }
    }

    setItem(key: string, data: string): void {
        key = key === undefined ? 'undefined' : (key === null ? 'null' : key);
        this.data[key] = data === undefined ? 'undefined' : (data === null ? 'null' : data.toString());
    }
}

export const IN_MEMORY_CACHE_STORAGE = new InMemoryCacheStorage();